export function decodeJwt(token) {
    const parts = token.split(".");
    if (parts.length !== 3)
        return null;
    try {
        const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4);
        const json = atob(padded);
        const decoded = decodeURIComponent(Array.from(json)
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""));
        return JSON.parse(decoded);
    }
    catch {
        return null;
    }
}
export function rolesFromPayload(payload) {
    const roles = new Set();
    for (const value of [
        payload.roles,
        payload.role,
        payload.permissions,
        payload["https://token.nevo.at/roles"],
        payload["https://token.nevo.at/role"],
    ]) {
        collectRoles(value, roles);
    }
    for (const [claim, value] of Object.entries(payload)) {
        if (/[:/]roles?$/.test(claim)) {
            collectRoles(value, roles);
        }
    }
    return [...roles];
}
function collectRoles(value, roles) {
    if (typeof value === "string") {
        value
            .split(/[,\s]+/)
            .map((role) => role.trim())
            .filter(Boolean)
            .forEach((role) => roles.add(role));
        return;
    }
    if (Array.isArray(value)) {
        value.forEach((role) => collectRoles(role, roles));
    }
}
//# sourceMappingURL=jwt.js.map